import { useState, useEffect } from 'react';

import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import { PanelistCard } from './Cards';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

export function EarningPotential() {
  const [coachType, setCoachType] = useState('Instructor');
  const [valuePerSession, setValuePerSession] = useState(1000);
  const [stepValue, setStepValue] = useState(1);
  const [totalEarning, setTotalEarning] = useState(1000);
  const handleChangeReverse = (value) => {
    setStepValue(value);
  };
  useEffect(() => {
    if (coachType === 'Mentor') {
      setValuePerSession(1000);
      setTotalEarning(stepValue * valuePerSession);
    }
    if (coachType === 'Instructor') {
      setValuePerSession(8333);
      setTotalEarning(stepValue * valuePerSession);
    }
  }, [coachType, stepValue, totalEarning, valuePerSession]);
  return (
    <div className="my-10 flex w-full flex-col items-center rounded-md bg-blue-12 p-8 lg:px-[4rem]">
      <h2 className="heading-2 my-2 mb-5 text-[36px]">Calculate earning potential</h2>
      <div className="flex w-full flex-col items-start justify-center">
        <div className="px-4 py-2 text-lg">Select coach type</div>
        <div className="grid grid-cols-2 items-start justify-around gap-4 lg:grid-flow-col lg:grid-cols-3">
          <button
            onClick={() => setCoachType('Instructor')}
            className={
              coachType === 'Instructor'
                ? 'w-md mb-4 rounded-md border border-red bg-white py-4 px-4 text-xl text-red lg:mx-4'
                : 'w-md mb-4 rounded-md bg-white py-4 px-4 text-xl text-gray-text-3 lg:mx-4'
            }
          >
            <div>Instructor</div>
          </button>
          <button
            onClick={() => setCoachType('Mentor')}
            className={
              coachType === 'Mentor'
                ? 'w-md mb-4 rounded-md border border-red bg-white py-4 px-4 text-2xl text-red lg:mx-4'
                : 'w-md mb-4 rounded-md bg-white py-4 px-4 text-2xl text-gray-text-3 lg:mx-4'
            }
          >
            <div>Mentor</div>
          </button>
        </div>
        <div className="w-md range mt-10 w-full rounded-md bg-white py-8 px-2 lg:p-10">
          <span className="font-satoshi-medium font-semibold">Select sessions per month</span>
          <div className="hidden lg:block">
            <Slider
              min={1}
              max={24}
              step={1}
              start={6}
              value={stepValue}
              orientation="horizontal"
              tooltip={false}
              onChange={handleChangeReverse}
              labels={{
                1: '1',
                2: '2',
                3: '3',
                4: '4',
                5: '5',
                6: '6',
                7: '7',
                8: '8',
                9: '9',
                10: '10',
                11: '11',
                12: '12',
                13: '13',
                14: '14',
                15: '15',
                16: '16',
                17: '17',
                18: '18',
                19: '19',
                20: '20',
                21: '21',
                22: '22',
                23: '23',
                24: '24',
              }}
              className="lg:text-small font-satoshi-bold text-xs font-bold "
            />
          </div>
          <div className="block lg:hidden">
            <Slider
              min={1}
              max={24}
              step={1}
              start={6}
              value={stepValue}
              orientation="horizontal"
              tooltip={false}
              onChange={handleChangeReverse}
              labels={{
                2: '2',
                4: '4',
                6: '6',
                8: '8',
                10: '10',
                12: '12',
                14: '14',
                16: '16',
                18: '18',
                20: '20',
                22: '22',
                24: '24',
              }}
              className="lg:text-small font-satoshi-bold text-xs font-bold "
            />
          </div>
        </div>
        <div className="mt-8 px-1 py-2 text-lg">Earn monthly up to:</div>
        <div className="flex items-start justify-evenly lg:gap-4">
          <div
            className={'mb-4 flex flex-col rounded-md bg-white p-6 text-center text-xl text-red'}
          >
            <div className="font-satoshi-bold text-2xl font-bold ">Rs {totalEarning}</div>
            <div className="text-xs">Fixed ( Rs. {valuePerSession} per session)</div>
          </div>
          {/* <div className={" text-5xl mb-4 p-4"}>+</div>
          <div
            className={
              "bg-white flex flex-col p-6 rounded-md text-xl mb-4 text-red text-center"
            }
          >
            <div className='text-2xl font-satoshi-bold font-bold '>Rs 10,000</div>
            <div className='text-xs'>Variable - depends on performance</div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export function NotAlone({ coaches, deviceType }) {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 679 },
      items: 2.5,
    },
    mobile: {
      breakpoint: { max: 678, min: 0 },
      items: 2,
    },
  };
  return (
    <div className="my-10 mx-auto flex max-w-md flex-col items-center p-8 lg:max-w-5xl">
      <h2 className="heading-2 mb-4">You are not alone</h2>
      <p className="text-para mb-8 text-center text-lg">
        Our coaches are extremely passionate and skilled engineers, product managers and subject
        matter experts from leading tech organisations and institutions.
      </p>
      <div className="flex w-full items-center md:w-full lg:mx-0">
        <Carousel
          swipeable={true}
          draggable={true}
          responsive={responsive}
          arrows={true}
          ssr={true} // means to render carousel on server-side.
          // infinite={true}
          partialVisible={true}
          itemClass="slider-crousel"
          keyBoardControl={true}
          containerClass="carousel-container"
          // removeArrowOnDeviceType={["tablet", "mobile"]}
          deviceType={deviceType}
          dotListClass="owl-dots"
          showDots={false}
          autoPlay={false}
          // customTransition='all .5'
        >
          {coaches.map((coach) => (
            <PanelistCard
              key={coach.id}
              name={coach.attributes.Name}
              image={
                coach?.attributes?.DisplayPicture?.data?.attributes?.formats.thumbnail.url ||
                coach?.attributes?.DisplayPicture?.data?.attributes.url
              }
              designation={coach.attributes.Designation}
              company={coach?.attributes?.CompanyImage?.data?.attributes?.url}
              linkedinUrl={coach.attributes.LinkedInUrl}
            />
          ))}
        </Carousel>
      </div>
    </div>
  );
}
